import ImageryProvider from "terriajs-cesium/Source/Scene/ImageryProvider";
import URI from "urijs";
function getUrlForImageryTile(imageryProvider, x, y, level) {
  const oldLoadImage = ImageryProvider.loadImage;
  let tileUrl;
  try {
    ImageryProvider.loadImage = function (_imageryProvider, url) {
      if (typeof url === "string" || url instanceof String) {
        tileUrl = url;
      } else if (url.url) {
        var _ionEndpoint;
        tileUrl = url.url;

        // Add the Cesium Ion access token if there is one (for an IonResource).
        const ionAccessToken = (_ionEndpoint = url._ionEndpoint) === null || _ionEndpoint === void 0 ? void 0 : _ionEndpoint.accessToken;
        if (ionAccessToken) {
          tileUrl = new URI(tileUrl).addQuery("access_token", ionAccessToken).toString();
        }
      }
      return undefined;
    };
    imageryProvider.requestImage(x, y, level);
  } finally {
    ImageryProvider.loadImage = oldLoadImage;
  }
  return tileUrl;
}
export default getUrlForImageryTile;